module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAMAAACfWMssAAAARVBMVEVHcEz///+kq7OkqrOkqrOkqrOtrbekqrOkqrOlqrSkqrSlqrOnr7ikqrOtrbakqrSkqrOqqrSlqrS+wsj19fb///+lqrVF8RYOAAAAF3RSTlMAAWXI8v8ZvbxmybYd8xxjxxi7////ZFKQFw8AAACVSURBVHgB7ZZDosAwFACjqa373/Sj2PfVmk0bTCz1HD60sY6ZOGv05Hk+IgJvrE/oga97MURM2IsRECdqJkkM2P43BTI1mwxI+z8AJQDgnuIn6rxwTAjEsgIWiLpimWhYKFqgbppaLKZA07bNceLipnZw8HTIF4B8yX0b+X7i4ktn8TW3+GJdfJWLHw++t/i58hg+fgHdKBIkFIzjFgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/f0_icon_pay@2x.png
// module id = h71F
// module chunks = 1